import { InfopankAccessLevel } from '@/apiTypes/types';

export const accessPublic = 'public';

export const fullInfopankAccess = (accessLevel?: InfopankAccessLevel) => accessLevel === 'Full';
